import axios from "axios";
import { JwtPayload } from "jsonwebtoken";
import { jwtDecode } from "jwt-decode";
import api from "./api"

export function checkForExpiredToken(tokenArg?: string) {
  const token = tokenArg || sessionStorage.getItem("auth-token");
  if (!token) return false;

  const decode = jwtDecode<JwtPayload>(token);
  const expirationTime = decode && decode.exp ? decode.exp * 1000 : 0;

  if (Date.now() >= expirationTime) {
    localStorage.clear();
    localStorage.setItem("session", JSON.stringify("expired"));
    return false;
  }

  return true;
}

export const AttemptSignInOnMount = async () => {
  let token = sessionStorage.getItem("auth-token");

  if (token === null) {
    sessionStorage.setItem("auth-token", "");
    token = "";
    console.log("no token found");
    return false;
  } else {
    const res = await axios.post("/api/tokenIsValid", null, {
      headers: { "x-auth-token": token },
    });

    if (res.data) {
      return true;
    }

    return false;
  }
};

export const SignIn = async (email: string, password: string) => {
  try {
    const dateString = new Date().toLocaleString();
    const dateFormat = dateString.replace(",", " at");

    const response = await axios.post("/api/signin", {
      email,
      password,
      date: dateFormat,
    });

    const { token, id, dealer, role, dealerTax, dealerLogo } =
      response.data;

    sessionStorage.setItem("user", JSON.stringify(id));
    sessionStorage.setItem("role", JSON.stringify(role));
    sessionStorage.setItem("email", JSON.stringify(response.data.email));
    sessionStorage.setItem("dealer", JSON.stringify(dealer));
    sessionStorage.setItem("auth-token", token);
    sessionStorage.setItem("dealerLogo", JSON.stringify(dealerLogo))
    sessionStorage.setItem("region", JSON.stringify(response.data.region));
    !response.data.hideTips &&
      sessionStorage.setItem("showTips", JSON.stringify(true));
    dealerTax !== 0 && sessionStorage.setItem("dealerTax", JSON.stringify(dealerTax));
    localStorage.removeItem("session");

    return { id };
  } catch (err) {
    console.log("issue with sign in");
    return { error: "User not found" };
  }
};

export const checkVersion = async() => {
  try{
    const res = await api.get("/api/checkVersion");
    if(res.data === "refresh"){
      return window.location.reload()
    }
  }catch(err){
    console.log(err)
  }
}